<template>
  <impersonate v-if="store.impersonation?.id && store.impersonation?.email"></impersonate>
</template>

<script setup lang="ts">
import Impersonate from './banners/impersonate.vue';
import { useStore } from '@/store';

const store = useStore();
</script>
